"use client";

import { addToast, Button } from "@heroui/react";
import { useMutation } from "@tanstack/react-query";
import { useForm } from "react-hook-form";
import { services } from "../../../../public/services";
import { ArrowLeft } from "lucide-react";
import { useState } from "react";

export default function ForgotPassword() {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      email: "",
    },
  });
  const [isLoading, setIsLoading] = useState(false);

  const forgotMutation = useMutation({
    mutationFn: (payload) => services.auth.forgotpassword.call(payload),
    onSuccess: (res) => {
      setIsLoading(false);
      addToast({
        title: "Success",
        description: "Reset link sent to your email!",
        color: "success",
      });
    },
    onError: (error) => {
      setIsLoading(false);
      addToast({
        title: "Error",
        description: error.response.data.email
          ? error.response.data.email
          : "Failed to Forgot Password",
        color: "danger",
      });
    },
  });

  const onSubmit = async (values) => {
    setIsLoading(true);
    const payload = {
      email: values.email,
    };
    forgotMutation.mutate(payload);
  };

  return (
    <div>
      <header className="mb-8 text-center">
        <h1 className="text-3xl font-bold tracking-tight text-black">
          Forgot Password
        </h1>
        <p className="mt-2 text-sm text-[var(--primary)]">
        Enter your registered email to receive a password reset link and securely change your password.
        </p>
      </header>

      <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
        {/* Email */}
        <div>
          <label
            htmlFor="email"
            className="mb-2 block text-sm font-medium text-foreground"
          >
            Email
          </label>
          <input
            id="email"
            type="email"
            placeholder="Enter email"
            className="block w-full rounded-lg border border-[var(--border)] bg-[var(--color-card)] px-3 py-3 text-[15px] text-foreground placeholder:text-muted-foreground/70 outline-none focus:border-[var(--color-ring)]"
            {...register("email", {
              required: "Email is required",
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: "Enter a valid email address",
              },
            })}
            aria-invalid={errors.email ? "true" : "false"}
            aria-describedby={errors.email ? "email-error" : undefined}
          />
          {errors.email && (
            <p id="email-error" className="mt-2 text-sm text-red-500">
              {errors.email.message}
            </p>
          )}
        </div>

        {/* Submit */}
        <Button
          type="submit"
          disabled={isLoading}
          className="w-full btn-primary px-4 py-3 text-center text-base font-semibold text-[var(--color-brand-foreground)] hover:opacity-95 disabled:opacity-70"
        >
          {isLoading ? "Submiting..." : "Submit"}
        </Button>

        <div className="flex items-center justify-center">
          <a
            href="/login/"
            className="flex items-center gap-1 text-sm font-medium text-[var(--primary)] hover:underline"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to login
          </a>
        </div>
      </form>
    </div>
  );
}
